import {
	Card,
	CardContent,
	Skeleton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	Typography,
} from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { getEuDdpOrder, getEuDdpOrderIsLoad } from 'redux/reducers/euDdp/selectors';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';

export const AmountBreakdown: FC = () => {
	const order = useSelector(getEuDdpOrder);
	const orderIsLoading = useSelector(getEuDdpOrderIsLoad);

	return (
		<div>
			{order && !orderIsLoading ? (
				<Card
					sx={{
						mb: 2,
						'&': {
							borderRadius: '12px',
						},
					}}
				>
					<CardContent>
						<Typography sx={{ fontSize: 14 }} color="primary" gutterBottom>
							Initial Order Info
						</Typography>
						<TableContainer>
							<Table>
								<TableBody>
									<TableRow>
										<TableCell sx={{ padding: '5px', borderBottom: 0 }}>Products Amount:</TableCell>
										<TableCell align="right" sx={{ padding: '5px', borderBottom: 0 }}>
											<AmountAndCurrency
												amount={order?.order.totalMerchCost ?? 0}
												currency={order?.order.paymentCurrency ?? 'EUR'}
											/>
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell sx={{ padding: '5px', borderBottom: 0 }}>Delivery Cost:</TableCell>
										<TableCell align="right" sx={{ padding: '5px', borderBottom: 0 }}>
											<AmountAndCurrency
												amount={order?.order.deliveryCost ?? 0}
												currency={order?.order.paymentCurrency ?? 'EUR'}
											/>
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell sx={{ padding: '5px', borderBottom: 0 }}>
											Taxes and Duties:
										</TableCell>
										<TableCell align="right" sx={{ padding: '5px', borderBottom: 0 }}>
											<AmountAndCurrency
												amount={
													(order?.order.totalCustomDuties ?? 0) + (order?.order.totalVat ?? 0)
												}
												currency={order?.order.paymentCurrency ?? 'EUR'}
											/>
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell sx={{ padding: '5px', borderBottom: 0 }}>Total Amount:</TableCell>
										<TableCell align="right" sx={{ padding: '5px', borderBottom: 0 }}>
											<AmountAndCurrency
												amount={order?.order.totalOrderValue ?? 0}
												currency={order?.order.paymentCurrency}
											/>
										</TableCell>
									</TableRow>

									{(order?.order.importThreshold ?? 0) > 0 && (
										<TableRow>
											<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
												Calculated Import Threshold:
											</TableCell>
											<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
												<AmountAndCurrency
													amount={order?.order.importThreshold ?? 0}
													currency={order?.order.thresholdCurrency ?? 'EUR'}
													size={0.9}
												/>
											</TableCell>
										</TableRow>
									)}
									{+(order?.order.importThreshold ?? 0) > 0 &&
										order?.order.paymentCurrency !== order?.order.thresholdCurrency && (
											<TableRow>
												<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
													Threshold Exchange Rate Applied:
												</TableCell>
												<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
													<AmountAndCurrency
														amount={1}
														currency={order?.order.paymentCurrency ?? 'EUR'}
														size={0.9}
														afterPoint={0}
													/>{' '}
													={' '}
													<AmountAndCurrency
														amount={order?.order.intrinsicThresholdExchangeRate ?? 1}
														currency={order?.order.thresholdCurrency ?? 'EUR'}
														size={0.9}
														afterPoint={6}
													/>
												</TableCell>
											</TableRow>
										)}

									{!!order?.order.dailyExchangeRate &&
										order?.order.paymentCurrency !== order?.order.thresholdCurrency && (
											<TableRow>
												<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
													Daily Exchange Rate:
												</TableCell>
												<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
													<AmountAndCurrency
														amount={1}
														currency={order?.order.paymentCurrency ?? 'EUR'}
														size={0.9}
														afterPoint={0}
													/>{' '}
													={' '}
													<AmountAndCurrency
														amount={order?.order.dailyExchangeRate ?? 1}
														currency={order?.order.thresholdCurrency ?? 'EUR'}
														size={0.9}
														afterPoint={6}
													/>
												</TableCell>
											</TableRow>
										)}
								</TableBody>
							</Table>
						</TableContainer>
					</CardContent>
				</Card>
			) : (
				<Skeleton variant="rectangular" height="128px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</div>
	);
};
